<div class="mb-3">
  @if (!hideLabel) {
    <label
      class="form-label"
      [attr.for]="inputId">
      {{ getLabel() }}
    </label>
  }

  <ngx-intl-tel-input
    [cssClass]="'form-control ' + validityClass"
    [numberFormat]="PhoneNumberFormat.National"
    [preferredCountries]="preferredCountries"
    [enableAutoCountrySelect]="true"
    [enablePlaceholder]="true"
    [searchCountryFlag]="true"
    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
    [selectFirstCountry]="true"
    [phoneValidation]="true"
    [separateDialCode]="true"
    [formControl]="internalControl"
    [inputId]="inputId"
    [attr.name]="fieldControl">
  </ngx-intl-tel-input>
  <bo-form-field-errors></bo-form-field-errors>
</div>
